module.exports = __webpack_public_path__ + "img/house-turret.6227806b.svg";